import React from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../modules/auth'

type Props = {
  allowedRoles?: string[]
  allowedAccountTypes?: string[]
  children: React.ReactNode
  redirectTo?: string
}

const RoleProtectedRoute: React.FC<Props> = ({
  allowedRoles,
  allowedAccountTypes,
  children,
  redirectTo = '/error/404',
}) => {
  const {currentUser} = useAuth()
  const roleAllowed =
    !allowedRoles || allowedRoles.length === 0 || allowedRoles.includes(currentUser?.role || '')
  const accountTypeAllowed =
    !allowedAccountTypes ||
    allowedAccountTypes.length === 0 ||
    allowedAccountTypes.includes(currentUser?.account_type || '')

  if (!currentUser || !roleAllowed || !accountTypeAllowed) {
    return <Navigate to={redirectTo} replace />
  }
  return <>{children}</>
}

export default RoleProtectedRoute